import { Component, OnInit, Optional, Inject, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatChipInputEvent } from '@angular/material/chips';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { KeyValue } from '@angular/common';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-v-mobilescrparams',
  templateUrl: './v-mobilescrparams.component.html',
  styleUrls: ['./v-mobilescrparams.component.scss']
})
export class VMobilescrparamsComponent implements OnInit {
  fromPage: string[];
  devRowEditable: boolean = false;
  title: string;
  baseUrl: string;
  url: string;

  @Output() childTitleEvent = new EventEmitter<string>();


  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  CVIP: string[] = [];
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.CVIP.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(chip: string): void {
    const index = this.CVIP.indexOf(chip);

    if (index >= 0) {
      this.CVIP.splice(index, 1);
    }
  }

  //https://www.w3schools.com/js/js_json_objects.asp
  //https://www.w3schools.com/js/js_json_arrays.asp
  GlobalDeviceHeaders = {
    "Remote IP (CVIP): (Use % between IPs)": { "key": "CVIP", "value": "" },//{ "CVIP": ["CVIP1", "CVIP2"] }, Multiple values - Mat chips
    "Global Device1 (GD1): (Ex: 1..8, ?, ?+1, R1..8, R? remote)": { "key": "GD1", "value": "" },
    "Global Device2 (GD2): (Ex: 1..8, ?, ?+1, R1..8, R? remote)": { "key": "GD2", "value": "" },
    "Global Phone1:": { "key": "GP1", "value": "" },
    "Global Phone2:": { "key": "GP2", "value": "" }
  };

  //https://stackoverflow.com/questions/48402215/loop-through-array-of-json-object-with-ngfor-angular-4
  StartVariableHeaders = {
    "Place Call (PC): (Use % between numbers)": [{ "key": "PC", "value": "" }],
    "Call ID (CI): (Use % between numbers)": [{ "key": "CI", "value": "" }],
    //"Call Type (CTO + CTT)": [{ "key": "CTO", "value": "" }, { "key": "CTT", "value": "" }],
    //"Transmit Digits (TD): (Use % between numbers)": [{ "key": "TD", "value": "" }],
    //"Set Sample Rate (SR)": [{ "key": "SR", "value": "" }],
    //"Variable INI File (VF)": [{ "key": "VF", "value": "" }]
  };
  trackByFn(index: any, item: any) {
    return index;
  }
  dummyData = [{ CD: "jdfhksdhfsd", PC: "sfsdkfjhsdkjfh" }];


  constructor(private http: HttpClient, public dialogBox: MatDialogRef<VMobilescrparamsComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.baseUrl = environment.urlAddress + '/api/';

    this.fromPage = data.pageValue;//device ID
    //console.log(data.pageValue)
    this.devRowEditable = data.devRowEditable;

    //console.log(data.devRowEditable);

    this.BindScrParams(data.pageValue);
  }

  ngOnInit() {
  }


  Close() {
    this.dialogBox.close(this.successMsg);
  }
  scrParamsData: any[];
  successMsg: boolean = false;
  BindScrParams(devID: number) {
    this.successMsg = false;
    this.GetScrParams(devID).subscribe((res: any) => {
      // console.log(res);
      let rows: any[] = JSON.parse(res) as any[];
      //debugger;
      //console.log(rows);
      this.scrParamsData = rows;
      for (var obj of rows) {
        //for (const key in this.GlobalDeviceHeaders) {
        //  if (this.GlobalDeviceHeaders[key]) {
        //    if (this.GlobalDeviceHeaders[key].key == obj.ParameterName_Abs) {
        //      this.GlobalDeviceHeaders[key].value = obj.ParameterValue_Abs;
        //      break;
        //    }
        //  }
        //}

        for (const key in this.StartVariableHeaders) {
          if (this.StartVariableHeaders[key]) {
            let valueArr = this.StartVariableHeaders[key];
            for (const subKey in valueArr) {
              if (valueArr[subKey]) {
                if (valueArr[subKey].key == obj.ParameterName_Abs) {
                  valueArr[subKey].value = obj.ParameterValue_Abs;
                  break;
                }
              }
            }
          }
        }
      }
      //console.log(this.GlobalDeviceHeaders);
      //console.log(this.StartVariableHeaders);
    });
  }
  UpdateScrParam() {
    if (!this.devRowEditable)
      this.Close();
    else {
      //https://stackoverflow.com/questions/37673454/javascript-iterate-key-value-from-json
      //console.log(this.GlobalDeviceHeaders["Remote IP (CVIP): (Use % between IPs)"]["key"])
      //console.log(this.StartVariableHeaders)
      this.scrParamsData = [];
      //for (const key in this.GlobalDeviceHeaders) {
      //  if (this.GlobalDeviceHeaders[key]) {
      //    this.scrParamsData.push({ DevID_Abs: this.fromPage, ParameterName_Abs: this.GlobalDeviceHeaders[key].key, ParameterValue_Abs: this.GlobalDeviceHeaders[key].value })
      //  }
      //}
      for (const key in this.StartVariableHeaders) {
        if (this.StartVariableHeaders[key]) {
          let valueArr = this.StartVariableHeaders[key];
          //console.log(valueArr)
          for (const subKey in valueArr) {
            //console.log(valueArr[subKey])
            if (valueArr[subKey]) {
              //console.log(valueArr[subKey].key)
              this.scrParamsData.push({ DevID_Abs: this.fromPage, ParameterName_Abs: valueArr[subKey].key, ParameterValue_Abs: valueArr[subKey].value })
            }
          }
        }
      }
      //console.log(this.scrParamsData)
      this.UpdatevMobileScrParamData(this.scrParamsData).subscribe((res: any) => {
        this.Close();
        this.successMsg = true;
      });
    }
  }

  parentEvent(title) {
    //debugger;

    this.title = title;
    this.childTitleEvent.emit(this.title);
  }

  GetScrParams(devID: number) {

    this.url = environment.urlAddress + '/api/' + 'NwStat_vMobile/GetScrParamsByDevID_New?devID=' + devID;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(this.url, { headers: headerOptions });

  }


  UpdatevMobileScrParamData(scrParamsData: any) {
    this.url = this.baseUrl + 'NwStat_vMobile/UpdateNwStat_vMobileScrParam';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, scrParamsData, options);
  }


  //https://stackoverflow.com/questions/52793944/angular-keyvalue-pipe-sort-properties-iterate-in-order
  //https://stackoverflow.com/questions/54091011/disable-the-default-keyvalue-pipe-sort-in-angular
  //https://stackoverflow.com/questions/53883433/how-to-disable-automatic-keyvalue-sorting-angular-6
  // Preserve original property order
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  // Order by ascending property value
  valueAscOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.value.localeCompare(b.value);
  }

  // Order by descending property key
  keyDescOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.key > b.key ? -1 : (b.key > a.key ? 1 : 0);
  }
}
